import { createContext, useContext } from "react";

// Lets ReactFlow-rendered node components read `resources` (they can't take props).
const DiagnosticFlowResourcesContext = createContext({});

export const DiagnosticFlowResourcesProvider = DiagnosticFlowResourcesContext.Provider;

export function useResources() {
  return useContext(DiagnosticFlowResourcesContext);
}
